import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import styled from 'styled-components';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox'; 
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import ActionSearch from 'material-ui/svg-icons/action/search';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import sortBy from 'lodash.sortby';

import { getUsersData, searchUser } from '../../actions/userActions';
import Pagination from '../Pagination/Pagination';
import UsersTable from './UsersTable';
import UserSearchResult from './UserSearchResult';
import LoadingState from '../Loading';

import {
  Header,
  UsersTableContainer,
  PaginationContainer,
  PageStateContainer,
  PageState
} from '../Styles/index';

const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 32px 16px;
`


class UserList extends Component {
  state = {
    currentPage: 1,
    totalPages: 1,
    limit: 20,
    users: [],
    orderBy: 'no',
    orderByItems: ['no', 'name', 'username', 'email'],
    showTable: true,
    activeFilter: false,

    searchQuery: ''
  }

  _handleSearchChange = event => {
    this.setState({
      [event.target.name]: event.target.value.trim()
    });

    if (event.target.value.trim() === '') {
      this.setState({
        showTable: true
      })
    } else {
      this.props.searchUser({ query: event.target.value.trim() });
      this.setState({
        showTable: false
      })
    }

  }

  _handleSearchSubmit = event => {
    event.preventDefault();
    this.props.searchUser({ query: this.state.searchQuery });
    this.setState({
      showTable: false
    })
  }

  _handleSearchBack = event => {
    this.setState({
      showTable: true,
      searchQuery: ''
    })
  }

  _onPageChange = page => {
    this.props.history.push(`${this.props.location.pathname}?page=${page}`);
    this.props.getUsersData({limit: this.state.limit, page: page})
    .then(res => {
      this.setState({
        users: sortBy(this.props.data.users, [this.state.orderBy]),
        activeUsers: sortBy(this.props.data.users.filter(user => user.active === true), [this.state.orderBy]),
        currentPage: page,
      })
    });
  }

  _handleChange = (event, index, value) => {
    const users = sortBy(this.state.users, [value]);
    const activeUsers = sortBy(this.state.activeUsers, [value]);
    console.log(sortBy(this.state.users, [value]));
    this.setState({
      orderBy: value,
      users: users,
      activeUsers: activeUsers
    });
  }


  _goToEditPage = (username) => {
    this.props.history.push(`/users/edit?user=${username}`);
  }

  _gotToOrdersPage = (username) => {
    this.props.history.push(`/users/${username}/orders`);
  }

  _refreshPage = () => {
    console.log("refreshPage");
    this.props.getUsersData({limit: this.state.limit, page: this.state.currentPage})
    .then(_ => {
      this.setState({
        users: this.props.data.users,
        activeUsers: this.props.data.users.filter(user => user.active === true),
      })
    });
  }

  componentDidMount() {

    const parsedQuery = queryString.parse(this.props.location.search);
    const page = (parsedQuery.page ? parsedQuery.page : 1) | 0;

    this.props.getUsersData({ limit: this.state.limit, page }).then(res => {
      this.setState({
        totalPages: this.props.data.lastPage || 0,
        users: this.props.data.users,
        activeUsers: this.props.data.users.filter(user => user.active === true),
        currentPage: page
      })
    });

  }

  render() {
    return (
      <Container>
        <Header>
          <div style={{flex: 1, height: '74px', paddingRight: '24px'}}>
            {!this.state.showTable &&
              <FlatButton
                style={{minWidth: '48px'}}
                type="submit"
                label="Back"
                onTouchTap={this._handleSearchBack}
                icon={<NavigationArrowBack />}
              />
            }
            {this.state.showTable && <SelectField
              floatingLabelText="Sort By"
              value={this.state.orderBy}
              onChange={this._handleChange}
            >
              {this.state.orderByItems.map((item, index) => <MenuItem key={index} value={item} primaryText={item}/>)}
            </SelectField>}
          </div>
          <div style={{padding: '16px 24px 16px 0'}}>
            {this.state.showTable && <Checkbox
              checked={this.state.activeFilter}
              onCheck={(event, checked) => {
                this.setState({
                  activeFilter: checked
                });
              }}
              label="Active"
            />}
          </div>
          <div>
            <form onSubmit={this._handleSearchSubmit}>
              <TextField
                name="searchQuery"
                id="searchQuery"
                onChange={this._handleSearchChange}
                value={this.state.searchQuery}
                hintText="Search users"
              />
              <FlatButton
                style={{minWidth: '48px'}}
                type="submit"
                icon={<ActionSearch />}
              />
            </form>
          </div>
        </Header>
        {this.props.data.loading 
          ? <LoadingState/>
          : <div>
              { this.state.showTable &&
                <div>
                  <UsersTableContainer>
                    {/* ['Id', 'Name', 'Username', 'Email', 'Actions']  ['Id', 'Name', 'Status'] */}
                    <UsersTable 
                      refreshPage={this._refreshPage} 
                      headers={['Id', 'Name', 'Username', 'Email', '']} 
                      tableData={this.state.activeFilter ? this.state.activeUsers : this.state.users} 
                      height={this.props.data.users.length*48} 
                      editHandler={this._goToEditPage}
                      gotToOrdersPage={this._gotToOrdersPage}
                    />
                  </UsersTableContainer>
                  <PaginationContainer>
                    <PageStateContainer>
                      <PageState>{this.state.currentPage} / {this.state.totalPages}</PageState>
                    </PageStateContainer>
                    <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this._onPageChange}/>
                  </PaginationContainer>
                </div>
              }
              { !this.state.showTable &&
                <div>
                  <UserSearchResult refreshPage={this._refreshPage} goToEditPage={this._goToEditPage} query={this.state.searchQuery} user={this.props.user}/>
                </div>
              }
            </div>
          }

      </Container>
    );
  }
}

const mapStateToProps = state => ({ data: state.users, user: state.user.searched });
const mapDispatchToProps = { getUsersData, searchUser };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserList));



// WEBPACK FOOTER //
// ./src/components/Users/UserList.js